import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" data-id="element-333">
      <div className="bg-[#FBF7F0] rounded-2xl max-w-2xl w-full max-h-[85vh] flex flex-col shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-334">
        <div className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-[#3E2723]/10" data-id="element-335">
          <h2 id="legal-modal-title" className="text-3xl md:text-4xl text-[#3E2723]" data-id="element-336">
            {title}
          </h2>
          <button onClick={onClose} aria-label="Close" className="w-10 h-10 rounded-full flex items-center justify-center text-[#3E2723] hover:bg-[#3E2723]/10 transition-colors" data-id="element-337">
            <X className="w-5 h-5" data-id="element-338" />
          </button>
        </div>
        <div className="px-6 md:px-8 py-6 overflow-y-auto text-[#3E2723]/85 space-y-4 text-base leading-relaxed" data-id="element-339">
          {children}
        </div>
      </div>
    </div>;
}